const RealizeFlash = {
	FlashDismiss: window.FlashDismiss,
};

export default class FlashDismiss extends RealizeFlash.FlashDismiss {

  handlerClick(e){
    this.focusNextElement();
    this.props.onClick(e);
  }

  focusNextElement () {
   
    if($(".flash").parents('.modal-content-container').length){
      $(".card-content h5").focus()
      return
    }
    //add all elements we want to include in our selection
    var focussableElements = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';
    if (document.activeElement && document.forms[0]) {
        var focussable = Array.prototype.filter.call(document.forms[0].querySelectorAll(focussableElements),
        function (element) {
            //check for visibility while always include the current activeElement 
            return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
        });
        var nextElement = focussable[0];
        nextElement.focus();               
    }
}

    render() {
        return (
          <div className={this.className()} onClick={this.handlerClick.bind(this)} tabindex="0" aria-label={Realize.i18n.t(`general.${this.props.type}.close`)}>
            <Icon type="close" aria-hidden="true"/>
          </div>
        );
    }

}